import Vue from 'vue'
import brazeHelper from '~/assets/util/braze'

function getBillingPeriod (intervalCount) {
	switch (intervalCount) {
			case 1:
				return 'monthly'
			case 6:
				return 'season'
			case 12:
				return 'annual'
			case 24:
				return 'two_years'
			default:
				return intervalCount ? `${intervalCount}_months` : undefined
	}
}

function getEmailSubscription (data, user, paymentUser) {
	const value = data.email_subscribe || data.is_receive_news || user.emailSubscribe || user.isReceiveNews || paymentUser.emailSubscribe || paymentUser.isReceiveNews
	return value === true || value === 'opted_in' ? 'opted_in' : undefined
}

function getStripeCustomerId (paymentUser) {
	return paymentUser.stripe_customer_id || paymentUser.stripeCustomerId || paymentUser.customerId || paymentUser.id
}

function getSubscriptionAttributes (activePlan = {}) {
	const software = activePlan.software || {}
	return {
		subscription_status: software.isPaused ? 'paused' : software.id ? 'active' : 'none',
		subscription_type: software.type || software.metadata?.type || activePlan.planName,
		subscription_price: software.price,
		billing_period: getBillingPeriod(software.intervalCount),
		currency: software.currency,
		next_invoice_date: activePlan.nextInvoice
	}
}

function getBrazeIdentifyAttributes ({ rootState, rootGetters }, data = {}) {
	const user = rootGetters['user/user'] || {}
	const selectedTeam = rootState.teams && rootState.teams.selected
	const paymentUser = rootState.user?.paymentUser || user.customer || {}
	const activePlan = rootGetters['plans/active'] || {}
	const permissions = rootGetters['user/permissions'] || {}
	const address = user.address || {}
	const campaign = rootState.user && rootState.user.utm
	return Object.assign({
		email: user.email,
		email_subscribe: getEmailSubscription(data, user, paymentUser),
		stripe_customer_id: getStripeCustomerId(paymentUser),
		name: user.fullName || user.name,
		firstName: user.firstName,
		lastName: user.lastName,
		first_name: user.firstName,
		last_name: user.lastName,
		country: address.country || rootGetters['user/origin'],
		phone: user.phone,
		has_vidswap_account: Boolean(selectedTeam?.custom?.vsActive || selectedTeam?.vsActive),
		isVerifiedAdmin: Boolean(permissions.isVerifiedAdmin),
		accountType: rootGetters['user/accountType'],
		teamId: selectedTeam && selectedTeam.id,
		campaign,
		...getSubscriptionAttributes(activePlan)
	}, data)
}

export const actions = {
	identify ({ rootState, rootGetters }, data = {}) {
		const userId = rootState.auth.user && rootState.auth.user.uid
		try {
			Vue.$segment.identify(userId, data)
		} catch (e) {
			this.$log.warn('Failed to do segment identify request', e)
		}
		brazeHelper.identifyBrazeUser(
			this.$brazeClient,
			userId,
			getBrazeIdentifyAttributes({ rootState, rootGetters }, data),
			this.$log
		)
	},

	group ({ rootState }, data) {
		try {
			const teamId = data.id || (rootState.teams.selected && rootState.teams.selected.id)

			if (data.id) {
				delete data.id
			}

			Vue.$segment.group(teamId, data)
		} catch (e) {
			this.$log.warn('Failed to do segment group request', e)
		}
	},

	track (store, { event, data }) {
		try {
			Vue.$segment.track(event, data)
			this.$log.debug('Analytics track', {
				event,
				data
			})
		} catch (e) {
			this.$log.warn('Failed to do segment track request', e)
		}
		brazeHelper.trackBrazeEvent(this.$brazeClient, event, data, this.$log)
	},

	reset (store) {
		try {
			Vue.$segment.reset()
		} catch (e) {
			this.$log.warn('Failed to do segment reset request', e)
		}
		brazeHelper.resetBrazeUser(this.$brazeClient, this.$log)
	},

	signUp (store, { userData, teamData = {}, accountType = 'team', isPurchaseFlow = false }) {
		try {
			const {
				email,
				phone,
				clubName,
				firstName = userData.name.split(' ')[0],
				lastName = userData.name.split(' ')[1],
				// eslint-disable-next-line camelcase
				address: { city, postal_code, state }
			} = userData

			const { role: teamRole, hearFrom: userSource } = teamData
			const eventName = isPurchaseFlow ? 'Wizard Purchase: Sign Up' : 'Wizard: Sign Up'

			store.dispatch('track', {
				event: eventName,
				data: {
					firstName,
					lastName,
					email,
					phone,
					address: {
						postalCode: postal_code,
						city,
						state
					},
					userSource,
					role: 'admin',
					teamRole,
					accountType,
					clubName,
					campaign: store.rootState.user.utm,
					client_type: 'Web'
				}
			})
		} catch (e) {
			this.$log.warn('Failed to do segment sign-up request', e)
		}
	},

	tikTokTrack (store, { event, data = {} }) {
		try {
			if (window.ttq) {
				if (data) {
					window.ttq.track(event, data)
				} else {
					window.ttq.track(event)
				}
				this.$log.debug('Analytics tiktok track', {
					event,
					data
				})
			}
		} catch (e) {
			this.$log.warn('Failed to do tiktok track request', e)
		}
	},

	facebookTrack (store, { event, data = {}, custom = false }) {
		const track = custom ? 'trackCustom' : 'track'
		try {
			if (data) {
				window.fbq(track, event, data)
			} else {
				window.fbq(track, event)
			}
			this.$log.debug('Analytics facebook track', {
				event,
				data
			})
		} catch (e) {
			this.$log.warn('Failed to do facebook track request', e)
		}
	}
}
